import { render, staticRenderFns } from "./skyDocNakladnoy.vue?vue&type=template&id=8abfbd54&scoped=true&"
import script from "./skyDocNakladnoy.vue?vue&type=script&lang=js&"
export * from "./skyDocNakladnoy.vue?vue&type=script&lang=js&"
import style0 from "./skyDocNakladnoy.vue?vue&type=style&index=0&id=8abfbd54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8abfbd54",
  null
  
)

export default component.exports